'use strict';

/* globals RELATIVE_PATH */

require([RELATIVE_PATH + '/plugins/nodebb-plugin-lessons/static/vendor/vue.js'], function (Vue) {
	Vue.component('answer-view', {
		props: ['initData', 'answer', 'answerTypes', 'answered'],
		data: function () {
			return {
				type: '',
				isSelected: false
			}
		},
		computed: {
			answerComponent: function () {
				return this.answer.type + '-answer-view';
			}
		},
		mounted: function () {
			var me = this;

			this.reset();

			this.$root.$on('resetQuestion', function () { me.reset(); });
		},
		methods: {
			select: function () {
				this.isSelected = true;

				this.answered(this.answer.isValid);
			},
			reset: function () {
				var me = this;

				this.type = this.answerTypes.find(function (item) { return item.type == me.answer.type; });
				this.isSelected = false;
			}
		},
		template: 
		'<div>' +
			'<div class="lesson-answer" :class="{ valid: isSelected && answer.isValid, invalid: isSelected && !answer.isValid }">' +
				'<div :is="answerComponent" :answer="answer"></div>' +
				'<button class="btn btn-primary select-answer" type="button" v-on:click="select()">{{initData.translations.selectAnswer}}</button>' +
			'</div>' +
		'</div>',
	});
});
